/* ============================================================================
   dntk-frei-player.js · DNTK-Radio & TV · Fassung 2026-10-24e (Bedienung wie in den PLUS-Karten; 2026-10-24d:
   Live-Sender aus stream_url; 2026-10-24c: reine Tondatei für „Nur Ton“ und Hintergrund; 2026-10-24b: App,
   „Nur Ton“ läuft bei gesperrtem Handy weiter; 2026-10-24: Freie Alben, DNTK-Video-Folgen direkt)
   Spielt in den Karten „Freies Album“ der Section dntk-premium-angebot die Folgen aus DNTK-Video direkt
   statt im iframe. Damit gibt es dort, was die PLUS-Inhalte im Radio schon haben:
     - Weiter ab: Die Stelle jeder langen Folge (ab 10 Minuten) wird auf diesem Gerät gemerkt
       (localStorage dntk_frei_pos, je Kennung { p, d, t }). Knopf der Folge: „Weiter ab 12:34“.
     - Nur Ton / Mit Bild: Umschalter in der Zeile unter dem Medienfeld, an derselben Stelle.
     - Hintergrund: Verschwindet die Seite (Sperrbildschirm, App-Wechsel), während ein Video spielt,
       geht es an derselben Stelle als Ton weiter; zurück auf der Seite wieder mit Bild. Bild-im-Bild bleibt
       Bild-im-Bild.
     - Fassung c: Gibt es zur Folge eine Tondatei (t, /ft/<uid>.m4a, reiner Ton ohne Bildspur), spielt „Nur Ton“
       und der Hintergrund diese Datei direkt im <audio> (ohne hls.js, spart Daten, Handys halten reinen Ton im
       Hintergrund nicht an). Ohne t oder wenn die Datei nicht lädt: wie bisher die kleinste HLS-Stufe, an
       derselben Stelle (eine kaputte Tondatei wird bis zum Neuladen der Seite nicht mehr versucht).
       Wird umgeschaltet (oder verschwindet die Seite), während eine Folge noch lädt, gilt ihre „Weiter ab“-Stelle
       statt 0, und sie spielt danach weiter, wenn sie starten sollte.
     - Am Ende einer Folge geht es mit der nächsten DNTK-Video-Folge des Albums weiter (auch im Hintergrund).
     - Fassung b: Die Android-App (WebView) hält beim Verbergen den Ton aus dem HLS-Stream im <audio> an
       (vermutlich wegen der Bildspur im Stream). Was nach dem Verbergen startet, läuft weiter (deshalb klappte
       der Weg Video → Ton). Hält der Tonspieler also an, ohne dass der Hörer, der Sperrbildschirm oder ein anderes
       Medium es wollte, und ist die Seite verborgen (oder wird es gleich danach), startet der Ton an
       derselben Stelle neu. Höchstens zweimal je Minute, nie in den ersten 3 s nach einem Start.
     - Sperrbildschirm (Media Session): Titel, Album, Cover, Abspielen/Pause, Titel vor/zurück.
     - Fassung d: Live-Sender. Zeilen mit data-live (https-HLS aus stream_url, die Section setzt es nur bei Streams
       ohne embed_code/medien_id) spielen den Stream live: keine gemerkte Stelle, „Nur Ton“ aus demselben Stream
       (kleinste passende Stufe), Titel vor/zurück wechselt sofort den Sender, am Ende kein automatischer Wechsel.
       Bleibt der Sender weg (403/404 oder mehrere Netzfehler), hält der Spieler an und meldet über h.hinweis
       „Dieser Sender ist gerade nicht erreichbar.“ (kein iframe-Rückfall).
     - Fassung e: Bedienung wie in den PLUS-Karten (assets/dntk-premium.js, gleiche Maße und Zeichen). In der Zeile
       unter dem Medienfeld (.dp__kopf), links neben „Teilen“: „Titel zurück“ und „Titel vor“ (ab zwei spielbaren
       Einträgen), Abspielen/Pause, die Zeit („1:33 / 3:33“, schmal nur „1:33“; live: „● LIVE“) und rechts der
       Umschalter „Nur Ton“/„Mit Bild“ als flaches Zeichen (eine Folge allein: mit Wort). Die Zeile steht, solange
       der Spieler offen ist, an der Stelle der kleinen Markenzeile. Im Spalt zwischen Medienfeld und Zeile liegt
       bei „Nur Ton“ eine dünne Fortschrittslinie zum Antippen und Ziehen (nicht live; mit Bild hat das Video seine
       eigene Bedienung). Der Tonspieler hat keine eigene Leiste mehr, über dem Cover steht nur der Titel. „Titel
       zurück“: nach mehr als 3 s an den Anfang, sonst zum vorigen Eintrag (live sofort zum vorigen Sender);
       „Titel vor“: nächster Eintrag, am letzten ausgegraut. Abspielen nach Pause holt einen Live-Sender neu (an
       die aktuelle Stelle des Senders). Wird während des Ladens angehalten, startet die Folge danach nicht von
       selbst. Fehlt der Section die Zeile: Umschalter im Medienfeld und Leiste des Tonspielers wie in Fassung d.
   Daten: frei-sync schreibt je TV-Stream das Feld dntk_video { k, m, s, d, t? } (Kennung, Hauptliste,
   kleinste Teilliste, Laufzeit, Tondatei falls vorhanden). Die Section legt es als data-video an die Zeile. Gespielt wird nur, wenn
   k zu der Kennung passt, die die Section sonst im iframe spielen würde; sonst bleibt alles beim iframe.
   YouTube, Twitch, Vimeo und Folgen ohne Daten laufen weiter im iframe der Section.

   Nur freie Videos: Pfade /media/hls/<32 Zeichen>/… und /ft/<dieselben 32 Zeichen>.m4a auf dem Medienserver
   (PLUS antwortet 403).
   Keine Anmeldung, kein Supabase, keine Engine nötig. hls.js wird erst beim Abspielen geladen; Safari/iOS
   spielt HLS selbst. WebView-Regeln wie im Radio: kein canplay, Start per setTimeout(50), stiller Dauerton.

   Öffentlich:
     DNTKFrei.binde(karte, h)  -> { kann(zeile), spiele(zeile), laeuft(), halteAn(), zuletzt() } | null
       h.vorStart()      vor jedem Start (Section: Vorschauen und iframes schließen)
       h.markiere(zeile) aktive Zeile zeigen (null = keine)
       h.rueckfall(zeile) Folge lässt sich direkt nicht spielen: Section spielt sie im iframe
       h.hinweis(text)   kurzer Hinweis (Live-Sender nicht erreichbar)
       h.aus()           Spieler ist zu (Section zeigt den Start-Knopf wieder)
     DNTKFrei.halteAlleAn()  alle direkt spielenden Folgen anhalten
   Beim Laden: Ereignis „dntk-frei:bereit“ am document.
   Regeln: Übergabe-Protokoll https://claude.ai/code/artifact/e5984669-eb75-4205-a1dd-857024ef1eaf
   ============================================================================ */
(function () {
  'use strict';
  if (window.DNTKFrei) { return; }

  var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
  var MEDIEN = 'https://media.managed-soft.de';
  var STILL = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQAAAAAAA==';
  var POS_KEY = 'dntk_frei_pos';
  var LANG = 600;             /* Stelle merken ab 10 Minuten Laufzeit (wie im Radio) */
  var MAX_STELLEN = 200;
  var KENN = /^[A-Za-z0-9_-]{6,20}$/;   /* wie dpQuelle in der Section */
  var MASTER = /^\/media\/hls\/([0-9a-f]{32})\/master\.m3u8$/;
  var TEIL = /^\/media\/hls\/([0-9a-f]{32})\/media-[0-9]{1,2}\/stream\.m3u8$/;
  var TON = /^\/ft\/([0-9a-f]{32})\.m4a$/;
  var tonKaputt = {};         /* Kennungen, deren Tondatei auf dieser Seite nicht lud (Fassung c) */
  var MS = ('mediaSession' in navigator) ? navigator.mediaSession : null;
  var MS_AKTIONEN = ['play', 'pause', 'stop', 'previoustrack', 'nexttrack', 'seekbackward', 'seekforward', 'seekto'];

  var spieler = [];           /* alle gebundenen Karten */
  var sitzung = null;         /* Spieler, der gerade die Bedienung im Sperrbildschirm hat */
  var fremdeMeta = null;

  /* ------------------------------------------------------------------ Hilfen */
  function zeit(s) {
    s = Math.max(0, Math.floor(Number(s) || 0));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
    return (h > 0 ? h + ':' + (m < 10 ? '0' : '') + m : String(m)) + ':' + (r < 10 ? '0' : '') + r;
  }
  function imHintergrund() { return document.visibilityState === 'hidden'; }
  function stellen() {
    try { return JSON.parse(localStorage.getItem(POS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function merke(k, sek, laenge) {
    if (!k) { return; }
    try {
      var p = stellen();
      if (!(laenge > LANG) || !sek || sek < 15 || sek > laenge - 30) { delete p[k]; }
      else { p[k] = { p: Math.floor(sek), d: Math.floor(laenge), t: Date.now() }; }
      var schluessel = Object.keys(p);
      if (schluessel.length > MAX_STELLEN) {
        schluessel.sort(function (a, b) { return (p[a].t || 0) - (p[b].t || 0); });
        schluessel.slice(0, schluessel.length - MAX_STELLEN).forEach(function (x) { delete p[x]; });
      }
      localStorage.setItem(POS_KEY, JSON.stringify(p));
    } catch (e) {}
  }
  function stelle(k) {
    var x = stellen()[k];
    return (x && x.p > 15) ? x : null;
  }
  function coverAdresse(url, breite) {
    url = String(url || '');
    if (!url) { return ''; }
    if (url.indexOf('//') === 0) { url = 'https:' + url; }
    if (/[?&]width=\d+/.test(url)) { return url.replace(/([?&]width=)\d+/, '$1' + breite); }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  }

  /* Kennung, die die Section für diese Zeile im iframe spielen würde (gleiche Reihenfolge wie dpQuelle):
     erst embed_code (allein stehende Kennung oder Adresse des Medienservers), sonst medien_id. */
  function kennungVon(z) {
    var roh = String(z.getAttribute('data-quelle') || '').trim();
    var kennung = String(z.getAttribute('data-kennung') || '').trim();
    var url = '';
    var m = roh.match(/src\s*=\s*["']([^"']+)["']/i);
    if (m) { url = m[1]; }
    else if (/^https?:\/\//i.test(roh)) { url = roh; }
    else if (KENN.test(roh)) { return roh; }
    if (!url) { return KENN.test(kennung) ? kennung : ''; }
    var u;
    try { u = new URL(url.replace(/&amp;/g, '&'), window.location.href); } catch (e) { return ''; }
    if (u.protocol !== 'https:' || u.hostname.replace(/^www\./, '') !== 'media.managed-soft.de') { return ''; }
    var mm = u.searchParams.get('m') || '';
    return KENN.test(mm) ? mm : '';
  }
  /* data-video der Zeile prüfen: nur freie HLS-Pfade auf dem Medienserver, passend zur Kennung. */
  function datenVon(z) {
    if (z.__dpf !== undefined) { return z.__dpf; }
    var v = null;
    try {
      var j = JSON.parse(z.getAttribute('data-video') || 'null');
      if (typeof j === 'string') { j = JSON.parse(j); }
      if (j && typeof j === 'object') {
        var a = MASTER.exec(String(j.m || '')), b = TEIL.exec(String(j.s || ''));
        var k = kennungVon(z);
        if (a && b && a[1] === b[1] && k && String(j.k) === k) {
          var c = TON.exec(String(j.t || ''));
          v = { k: k, m: MEDIEN + j.m, s: MEDIEN + j.s, d: Math.max(0, Number(j.d) || 0),
                t: (c && c[1] === a[1]) ? MEDIEN + j.t : '' };
        }
      }
      /* Fassung d: Live-Sender (nur https, HLS) */
      if (!v) {
        var roh = String(z.getAttribute('data-live') || '').trim();
        if (roh) {
          var lu = new URL(roh);
          if (lu.protocol === 'https:' && /\.m3u8$/i.test(lu.pathname)) {
            v = { k: 'live:' + lu.href, m: lu.href, s: lu.href, d: 0, t: '', live: true };
          }
        }
      }
    } catch (e) { v = null; }
    z.__dpf = v;
    return v;
  }

  /* ------------------------------------------------------------------ hls.js */
  function ladeHls() {
    if (window.Hls) { return Promise.resolve(window.Hls); }
    return new Promise(function (ok) {
      var s = document.createElement('script');
      s.src = HLS_SRC;
      s.async = true;
      s.onload = function () { ok(window.Hls || null); };
      s.onerror = function () { ok(null); };
      document.head.appendChild(s);
    });
  }
  /* Safari/iOS spielt HLS selbst: ohne hls.js, läuft dort auch bei gesperrtem Bildschirm stabil.
     Android und Desktop nehmen hls.js wie das Radio (eigenes HLS des Browsers nur als Rückfall). */
  var APPLE = /Apple/i.test(navigator.vendor || '');
  function kannSelbst(el) {
    try { return !!el.canPlayType('application/vnd.apple.mpegurl'); } catch (e) { return false; }
  }

  /* ------------------------------------------------------------------ wach halten
     Ein stiller Dauerton hält die Seite wach, solange eine Folge spielt (Wechsel zur nächsten Folge im
     Hintergrund). Wie im Radio und in der Engine. */
  var dauerton = null;
  function wach(an) {
    try {
      if (!dauerton) {
        if (!an || typeof Audio !== 'function') { return; }
        dauerton = new Audio(STILL);
        dauerton.loop = true;
      }
      if (an) { var p = dauerton.play(); if (p && p.catch) { p.catch(function () {}); } }
      else { dauerton.pause(); }
    } catch (e) {}
  }
  function wachPruefen() {
    setTimeout(function () {
      var spielt = spieler.some(function (s) { return s.spielt(); });
      if (!spielt) { wach(false); }
    }, 5000);
  }
  function radioAnhalten() {
    var r = document.getElementById('main-player');
    if (!r || r.paused || typeof window.togglePlay !== 'function') { return; }
    try { window.togglePlay(); } catch (e) {}
  }

  /* ------------------------------------------------------------------ Sperrbildschirm */
  function msAktion(a, f) {
    if (!MS) { return; }
    try { MS.setActionHandler(a, f); } catch (e) {}
  }
  function gibAb(s) {
    if (!sitzung || (s && sitzung !== s)) { return; }
    sitzung = null;
    if (!MS) { return; }
    MS_AKTIONEN.forEach(function (a) { msAktion(a, null); });
    try { MS.metadata = fremdeMeta; } catch (e) {}
    fremdeMeta = null;
    if (typeof window.setupMediaHandlers === 'function') { try { window.setupMediaHandlers(); } catch (e) {} }
  }

  /* Startet ein anderes Medium (Radio, PLUS-Karte, Hörprobe), halten die freien Folgen an. */
  document.addEventListener('play', function (e) {
    var el = e.target;
    if (!(el instanceof HTMLMediaElement)) { return; }
    var meiner = null;
    spieler.forEach(function (s) { if (s.besitzt(el)) { meiner = s; } });
    spieler.forEach(function (s) { if (s !== meiner) { s.fremd(); } });
  }, true);

  /* ------------------------------------------------------------------ CSS (einmal) */
  function stil() {
    if (document.getElementById('dntk-frei-player-stil')) { return; }
    var st = document.createElement('style');
    st.id = 'dntk-frei-player-stil';
    st.textContent =
      '.dpf{position:absolute;inset:0;z-index:4;background:#000 center/contain no-repeat}' +
      '.dpf[hidden]{display:none}' +
      '.dpf__video{position:absolute;inset:0;width:100%;height:100%;background:#000}' +
      '.dpf__video[hidden],.dpf__ton[hidden],.dpf__jetzt[hidden]{display:none}' +
      '.dpf__ton{position:absolute;left:8px;right:8px;bottom:8px;width:calc(100% - 16px);height:40px;z-index:2;color-scheme:dark}' +
      '.dpf__jetzt{position:absolute;top:0;left:0;right:0;z-index:1;margin:0;padding:.8rem 1.2rem 2rem;font-size:1.3rem;font-weight:600;' +
        'color:#fff;pointer-events:none;background:linear-gradient(to bottom,rgba(0,0,0,.7),transparent)}' +
      '.dpf__umschalt[hidden],[data-dpf-bedienung][hidden]{display:none!important}' +
      '.dp__teilen.dpf__umschalt svg{width:1.4rem;height:1.4rem;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
      '.dpf__stand{display:block;max-width:14rem;height:3px;margin-top:.4rem;border-radius:2px;overflow:hidden;background:rgba(var(--color-foreground),.14)}' +
      '.dpf__stand>span{display:block;height:100%;background:rgb(var(--dp-akzent,205,0,57))}';
    document.head.appendChild(st);
  }
  var ICON_TON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>';
  var ICON_BILD = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M10 9l5 3-5 3z"/></svg>';

  /* Fassung e: Bedienung in der Zeile, Maße und Zeichen wie in assets/dntk-premium.js (PLUS-Karten).
     Die Taste ist die unsichtbare Tippfläche (46 × 34 px), sichtbar ist ein flaches Feld darin (26 px hoch, wie
     „Teilen“). Abspielen/Pause ist gefüllt, die anderen Tasten haben nur einen Rand. */
  var FELD = 'display:flex;align-items:center;justify-content:center;width:100%;height:26px;box-sizing:border-box;' +
    'border-radius:8px;pointer-events:none;';
  var RAND = 'border:1px solid rgba(var(--color-foreground),.35);';
  var VOLL = 'border:1px solid rgb(var(--color-foreground));background:rgb(var(--color-foreground));color:rgb(var(--color-background,18,18,18));';
  var TASTE = 'width:46px;height:34px;min-width:34px;margin:0;padding:0;display:inline-flex;align-items:center;justify-content:center;flex:0 1 46px;' +
    'border:0;background:transparent;color:rgb(var(--color-foreground));cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;touch-action:manipulation;';
  var P_SPIEL = 'M8 5v14l11-7z';
  var P_PAUSE = 'M6 5h4v14H6zm8 0h4v14h-4z';
  var P_ZURUECK = 'M6 6h2v12H6zm3.5 6 8.5 6V6z';
  var P_VOR = 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z';
  var P_TON = 'M12 3a9 9 0 0 0-9 9v7a2 2 0 0 0 2 2h3v-8H5v-1a7 7 0 0 1 14 0v1h-3v8h3a2 2 0 0 0 2-2v-7a9 9 0 0 0-9-9z';
  var P_BILD = 'M21 3H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-6-7 4V7z';
  function zeichen(pfad) {
    return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" style="fill:currentColor;display:block"><path d="' + pfad + '"/></svg>';
  }
  function zeigeAn(el, an, art) {
    if (!el) { return; }
    el.hidden = !an;
    el.style.display = an ? art : 'none';
  }

  /* ------------------------------------------------------------------ eine Karte */
  function binde(karte, h) {
    h = h || {};
    if (!karte || karte.__dpfApi) { return karte ? karte.__dpfApi || null : null; }
    var medium = karte.querySelector('.dp__medium');
    if (!medium) { return null; }
    var zeilen = Array.prototype.slice.call(karte.querySelectorAll('[data-dp-frei-folge]'));
    var spielbar = zeilen.filter(function (z) { return !!datenVon(z); });
    if (!spielbar.length) { return null; }
    stil();

    var albumTitel = (karte.querySelector('.dp__titel') || {}).textContent || '';
    var artist = (karte.querySelector('.dp__artist') || {}).textContent || '';
    var albumBild = '';
    var teilen = karte.querySelector('[data-dp-teilen]');
    if (teilen) { albumBild = teilen.getAttribute('data-cover') || ''; }

    var box = document.createElement('div');
    box.className = 'dpf';
    box.hidden = true;
    box.setAttribute('data-dp-frei-spieler', '');
    var video = document.createElement('video');
    video.className = 'dpf__video';
    video.controls = true;
    video.preload = 'none';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('controlslist', 'nodownload');
    var audio = document.createElement('audio');
    audio.className = 'dpf__ton';
    audio.controls = true;
    audio.preload = 'auto';
    audio.hidden = true;
    audio.setAttribute('playsinline', '');
    audio.setAttribute('controlslist', 'nodownload');
    audio.setAttribute('data-dp-frei-ton', '');
    audio.setAttribute('aria-label', 'Wiedergabe');
    var jetztText = document.createElement('p');
    jetztText.className = 'dpf__jetzt';
    jetztText.hidden = true;
    box.appendChild(video);
    box.appendChild(jetztText);
    box.appendChild(audio);
    medium.appendChild(box);

    /* Fassung e: Bedienung wie in den PLUS-Karten in der Zeile unter dem Medienfeld (.dp__kopf), links neben
       „Teilen“: Titel zurück, Abspielen/Pause, Titel vor, Zeit, Umschalter „Nur Ton“/„Mit Bild“. Ohne die Zeile:
       nur der Umschalter, oben rechts im Medienfeld (wie vor Fassung e). */
    var kopf = karte.querySelector('.dp__kopf');
    var inZeile = !!(kopf && kopf.insertBefore);
    var album = spielbar.length > 1;
    var marke = kopf ? kopf.querySelector('.dp__marke') : null;
    var tastenBox = null, tasteZurueck = null, tasteSpiel = null, tasteVor = null, zeitEl = null, umschaltFeld = null;
    var leiste = null, fuell = null, griff = null;
    var felder = {};          /* sichtbares Feld je Taste */
    var eng = 0;              /* schmale Zeile: 1 = Umschalter ohne Wort, 2 = engere Abstände, 3 = nur die gespielte Zeit, 4 = ohne Zeit */
    var nurKurz = false;
    var umschaltInhalt = '';
    var stand = {};           /* zuletzt Gezeigtes: nur schreiben, wenn sich etwas ändert */
    var platzWert = 0;
    var ziehen = false, ziehAnteil = 0, zeiger = false, fokus = false;
    var haltLauf = -1;        /* Lauf, den der Hörer während des Ladens angehalten hat (startet dann nicht von selbst) */
    var umschalt = document.createElement('button');
    umschalt.type = 'button';
    umschalt.className = 'dpf__umschalt';
    function baueTaste(kennung, name, pfad, voll) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute(kennung, '');
      b.setAttribute('aria-label', name);
      b.setAttribute('title', name);
      b.style.cssText = TASTE;
      var feld = document.createElement('span');
      feld.style.cssText = FELD + (voll ? VOLL : RAND);
      feld.innerHTML = zeichen(pfad);
      b.appendChild(feld);
      felder[kennung] = feld;
      tastenBox.appendChild(b);
      return b;
    }
    if (inZeile) {
      tastenBox = document.createElement('span');
      tastenBox.setAttribute('data-dpf-bedienung', '');
      /* margin -4px: Die Tippfläche (34 px) ist höher als die Zeile (26 px), die Zeile behält ihre Höhe. */
      tastenBox.style.cssText = 'display:none;align-items:center;gap:6px;margin:-4px 0;flex:1 1 auto;min-width:0;';
      tastenBox.hidden = true;
      kopf.insertBefore(tastenBox, kopf.firstChild || null);
      if (album) { tasteZurueck = baueTaste('data-dpf-zurueck', 'Titel zurück', P_ZURUECK, false); }
      tasteSpiel = baueTaste('data-dpf-abspielen', 'Abspielen', P_SPIEL, true);
      if (album) { tasteVor = baueTaste('data-dpf-vor', 'Titel vor', P_VOR, false); }
      zeitEl = document.createElement('span');
      zeitEl.setAttribute('data-dpf-zeit', '');
      zeitEl.style.cssText = 'flex:0 0 auto;margin-left:2px;font-size:1.2rem;line-height:1;white-space:nowrap;' +
        'font-variant-numeric:tabular-nums;color:rgba(var(--color-foreground),.75);';
      zeitEl.textContent = '0:00';
      tastenBox.appendChild(zeitEl);
      /* Umschalter rechts in der Bedienung: Album nur mit Zeichen wie die Titel-Tasten, eine Folge allein mit Wort */
      umschalt.style.cssText = (album ? TASTE : TASTE.replace('width:46px;', 'width:auto;min-width:46px;').replace('flex:0 1 46px;', 'flex:0 0 auto;')) +
        'margin-left:auto;display:none;';
      umschaltFeld = document.createElement('span');
      umschaltFeld.style.cssText = FELD + RAND + (album ? '' : 'gap:5px;padding:0 9px;width:auto;min-width:46px;font-size:1.2rem;line-height:1;white-space:nowrap;');
      umschalt.appendChild(umschaltFeld);
      tastenBox.appendChild(umschalt);
      /* Der Tonspieler braucht keine eigene Leiste: Cover bleibt frei. */
      audio.controls = false;
      audio.removeAttribute('controls');

      /* Fortschrittslinie im Spalt zwischen Medienfeld und Zeile (oberer Innenabstand von .dp__inhalt) */
      var inhalt = karte.querySelector('.dp__inhalt');
      if (inhalt && inhalt.insertBefore) {
        var luft = 14;
        try {
          var cs = window.getComputedStyle(inhalt);
          var pt = parseFloat(cs.paddingTop);
          if (isFinite(pt) && pt >= 8) { luft = Math.min(pt, 24); }
          if (cs.position === 'static') { inhalt.style.position = 'relative'; }
        } catch (e) {}
        var spurOben = 8 + Math.max(0, Math.floor((luft - 3) / 2));
        leiste = document.createElement('div');
        leiste.setAttribute('data-dpf-leiste', '');
        leiste.setAttribute('role', 'slider');
        leiste.setAttribute('tabindex', '0');
        leiste.setAttribute('aria-label', 'Position im Titel');
        leiste.setAttribute('aria-valuemin', '0');
        leiste.setAttribute('aria-valuemax', '100');
        leiste.setAttribute('aria-valuenow', '0');
        leiste.style.cssText = 'display:none;position:absolute;z-index:1;left:4px;right:4px;top:-8px;height:' + (8 + Math.round(luft) - 2) + 'px;' +
          'cursor:pointer;outline:none;touch-action:pan-y;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent;';
        var spur = document.createElement('span');
        spur.style.cssText = 'position:absolute;left:0;right:0;top:' + spurOben + 'px;height:3px;border-radius:2px;overflow:hidden;' +
          'background:rgba(var(--color-foreground),.25);pointer-events:none;';
        fuell = document.createElement('span');
        fuell.style.cssText = 'display:block;width:0%;height:100%;background:rgb(var(--color-foreground));';
        spur.appendChild(fuell);
        griff = document.createElement('span');
        griff.style.cssText = 'position:absolute;left:0;top:' + (spurOben - 5) + 'px;width:13px;height:13px;border-radius:50%;' +
          'background:rgb(var(--color-foreground));box-shadow:0 0 0 1px rgba(0,0,0,.35);opacity:0;transition:opacity .15s;pointer-events:none;';
        leiste.appendChild(spur);
        leiste.appendChild(griff);
        inhalt.insertBefore(leiste, inhalt.firstChild || null);
      }
    } else {
      umschalt.className = 'dp__teilen dpf__umschalt';
      umschalt.style.cssText = 'position:absolute;top:8px;right:8px;z-index:5;';
      box.appendChild(umschalt);
    }
    umschalt.hidden = true;
    umschaltZeichen(false);

    var art = '';            /* 'bild' (Video im <video>) | 'ton' (kleinste Stufe im <audio>) */
    var wunschTon = false;   /* der Hörer hat „Nur Ton“ gewählt */
    var autoTon = false;     /* Ton nur, weil die Seite verschwunden ist */
    var aktuell = null;      /* { z, v, titel, bild } */
    var hls = null;
    var lauf = 0;
    var wechsel = 0;
    var angehalten = false;
    var istFremd = false;    /* ein anderes Medium hat übernommen */
    var offen = false;       /* Tonspieler schon einmal im Fingertipp gestartet (iOS) */
    var zuletztGemerkt = 0;
    var fehlerZahl = 0;
    var startZeit = 0;       /* letzter Start (starte) */
    var tonPause = 0;        /* letzte Pause des Tonspielers, die niemand wollte (Fassung b) */
    var neustarts = [];      /* Zeitpunkte der automatischen Neustarts (Fassung b) */
    var tonQuelle = null;    /* { nr, ab, sofort, lief }: der Tonspieler spielt gerade die Tondatei (Fassung c) */
    var startAb = 0;         /* Stelle, an der die laufende Folge starten soll (Fassung c) */
    var startDa = true;      /* die Folge ist an dieser Stelle angekommen (vorher meldet das Element oft 0) */
    var startSofort = false; /* der laufende Start soll abspielen (Fassung c) */
    var startGespielt = false; /* seit dem letzten Start schon einmal gespielt (Fassung c) */

    function el() { return art === 'ton' ? audio : video; }
    /* Fassung c: aktuelle Stelle; solange die Folge noch zur Startstelle lädt, die Startstelle statt 0 */
    function stelleJetzt(x) {
      var t = Number(x.currentTime) || 0;
      if (!startDa && startAb > 0 && t < 1) { return startAb; }
      return t;
    }
    /* Fassung c: spielt oder soll gleich spielen (Start angefordert, lädt noch, niemand hat angehalten) */
    function sollLaufen(x) {
      return !x.paused || (startSofort && !startGespielt && !angehalten);
    }
    function still() { return String(audio.getAttribute('src') || '').indexOf('data:') === 0; }

    function umschaltZeichen(ton) {
      var wort = ton ? 'Mit Bild' : 'Nur Ton';
      if (inZeile) {
        var mitWort = !album && eng < 1;
        var inhalt = zeichen(ton ? P_BILD : P_TON).replace('display:block', 'display:block;flex:0 0 auto') + (mitWort ? '<span>' + wort + '</span>' : '');
        if (inhalt !== umschaltInhalt) {
          umschaltInhalt = inhalt;
          umschaltFeld.innerHTML = inhalt;
          if (!album) { umschaltFeld.style.padding = mitWort ? '0 9px' : '0'; }
        }
      } else {
        umschalt.innerHTML = (ton ? ICON_BILD : ICON_TON) + '<span>' + wort + '</span>';
      }
      umschalt.setAttribute('aria-label', ton ? 'Wieder mit Bild' : 'Nur den Ton hören');
      umschalt.setAttribute('title', wort);
      umschalt.setAttribute('aria-pressed', ton ? 'true' : 'false');
    }
    /* Umschalter und (Fassung e) Bedienung zeigen, solange der Spieler offen ist; die Markenzeile macht Platz. */
    function zeigeUmschalt() {
      var an = !box.hidden && !!aktuell;
      if (an) { umschaltZeichen(art === 'ton'); }
      if (!inZeile) { umschalt.hidden = !an; return; }
      var vorher = !tastenBox.hidden;
      zeigeAn(tastenBox, an, 'flex');
      zeigeAn(umschalt, an, 'inline-flex');
      if (marke) { marke.style.display = an ? 'none' : ''; }
      if (vorher !== an) { platzWert = 0; stand = {}; }
      if (an) {
        if (tasteVor) {
          var n = nachbar(1);
          tasteVor.disabled = !n;
          tasteVor.style.opacity = n ? '1' : '.35';
          tasteVor.style.cursor = n ? 'pointer' : 'default';
        }
        if (tasteZurueck) {
          var z = !aktuell.v.live || !!nachbar(-1);
          tasteZurueck.disabled = !z;
          tasteZurueck.style.opacity = z ? '1' : '.35';
          tasteZurueck.style.cursor = z ? 'pointer' : 'default';
        }
        stand.text = null;
        passeZeile();
        bedienStand();
      }
      leisteStand();
    }

    /* ---------------------------------------------------------------- Bedienung (Fassung e) */
    function dauer() {
      if (!aktuell || aktuell.v.live) { return 0; }
      var d = Number(el().duration);
      return isFinite(d) && d > 0 ? d : 0;
    }
    /* Platz für die Zeit: Zeilenbreite ohne „Teilen“, ohne die Tasten und ohne den Umschalter */
    function platz() {
      if (platzWert > 0) { return platzWert; }
      var b = Number(kopf.clientWidth) || 0;
      if (!b) { return 0; }
      var tb = teilen && teilen.parentNode === kopf ? (Number(teilen.offsetWidth) || 0) + 10 : 0;
      var ub = !umschalt.hidden ? (Number(umschalt.offsetWidth) || 52) + 6 : 0;
      platzWert = b - tb - (album ? 3 : 1) * 52 - 2 - ub;
      return platzWert;
    }
    function bedienStand() {
      if (!inZeile || !aktuell || tastenBox.hidden) { return; }
      var x = el();
      var spielt = sollLaufen(x) && !x.ended;
      if (stand.spielt !== spielt) {
        stand.spielt = spielt;
        felder['data-dpf-abspielen'].innerHTML = zeichen(spielt ? P_PAUSE : P_SPIEL);
        tasteSpiel.setAttribute('aria-label', spielt ? 'Pause' : 'Abspielen');
        tasteSpiel.setAttribute('title', spielt ? 'Pause' : 'Abspielen');
      }
      if (aktuell.v.live) {
        if (stand.text !== 'LIVE') {
          stand.text = 'LIVE';
          stand.laenge = 4;
          zeitEl.innerHTML = '<i aria-hidden="true" style="display:inline-block;width:.7rem;height:.7rem;margin-right:.45rem;border-radius:50%;' +
            'background:currentColor;vertical-align:.05em"></i>LIVE';
          zeitEl.style.color = 'var(--dp-jetzt,#cd0039)';
          zeitEl.style.fontWeight = '800';
          zeitEl.style.letterSpacing = '.08em';
          passeZeile();
        }
        return;
      }
      if (stand.text === 'LIVE' || stand.text == null) {
        zeitEl.style.color = 'rgba(var(--color-foreground),.75)';
        zeitEl.style.fontWeight = '';
        zeitEl.style.letterSpacing = '';
      }
      var d = dauer();
      var t = ziehen ? ziehAnteil * d : stelleJetzt(x);
      if (d && t > d) { t = d; }
      var kurz = zeit(t);
      var lang = d ? kurz + ' / ' + zeit(d) : kurz;
      var text = (d && !nurKurz && lang.length * 7 <= platz()) ? lang : kurz;
      if (stand.text !== text) {
        var laengeVorher = stand.laenge;
        stand.text = text;
        stand.laenge = text.length;
        zeitEl.textContent = text;
        if (laengeVorher !== text.length) { passeZeile(); }
      }
      if (!leiste) { return; }
      var p = d ? Math.round(t / d * 1000) / 10 : 0;
      if (stand.p !== p) {
        stand.p = p;
        fuell.style.width = p + '%';
        griff.style.left = 'calc(' + p + '% - ' + (Math.round(13 * p) / 100) + 'px)';
        leiste.setAttribute('aria-valuenow', String(Math.round(p)));
      }
      var vt = d ? kurz + ' von ' + zeit(d) : kurz;
      if (stand.vt !== vt) { stand.vt = vt; leiste.setAttribute('aria-valuetext', vt); }
    }
    /* Linie nur bei „Nur Ton“ (Video mit Bild hat seine eigene Bedienung), nicht live */
    function leisteStand() {
      if (!leiste) { return; }
      var an = !box.hidden && !!aktuell && art === 'ton' && !aktuell.v.live;
      leiste.style.display = an ? 'block' : 'none';
      griff.style.opacity = (ziehen || zeiger || fokus) ? '1' : '0';
    }
    /* Schmale Zeile: erst das Wort am Umschalter weglassen, dann die Abstände enger, dann nur die gespielte Zeit,
       zuletzt die Zeit ausblenden. Gemessen wird nur bei Änderungen. */
    function passeZeile() {
      if (!inZeile || tastenBox.hidden || !(Number(tastenBox.clientWidth) > 0)) { return; }
      var zuViel = function () { return tastenBox.scrollWidth > tastenBox.clientWidth + 1; };
      var stufe = function (n) {
        eng = n;
        nurKurz = n >= 3;
        tastenBox.style.gap = n >= 2 ? '3px' : '6px';
        if (nurKurz && stand.text && stand.text.indexOf(' / ') !== -1) {
          stand.text = stand.text.split(' / ')[0];
          stand.laenge = stand.text.length;
          zeitEl.textContent = stand.text;
        }
        zeitEl.style.display = n >= 4 ? 'none' : '';
        if (!umschalt.hidden) { umschaltZeichen(art === 'ton'); }
      };
      var vorher = eng;
      stufe(0);
      while (eng < 4 && zuViel()) { stufe(eng + 1); }
      if (eng !== vorher) { platzWert = 0; }
    }
    function zeige(neueArt) {
      box.hidden = false;
      var ton = neueArt === 'ton';
      video.hidden = ton;
      audio.hidden = !ton;
      jetztText.hidden = !ton || !jetztText.textContent;
      var bild = aktuell && aktuell.bild;
      box.style.backgroundImage = (ton && bild) ? 'url("' + coverAdresse(bild, 1200).replace(/"/g, '%22') + '")' : '';
      zeigeUmschalt();
    }

    function hlsWeg() {
      if (!hls) { return; }
      try { hls.stopLoad(); } catch (e) {}
      try { hls.detachMedia(); } catch (e) {}
      try { hls.destroy(); } catch (e) {}
      hls = null;
    }
    function leere(x) {
      try { x.pause(); } catch (e) {}
      if (x === audio && still()) { return; }
      if (!x.getAttribute('src')) { return; }
      x.removeAttribute('src');
      try { x.load(); } catch (e) {}
    }
    function abspielen(x, nr) {
      if (nr === haltLauf) { return; }   /* Fassung e: während des Ladens angehalten: nicht von selbst starten */
      angehalten = false;
      var p;
      try { p = x.play(); } catch (e) { p = null; }
      if (p && p.catch) { p.catch(function () {}); }
      /* Wie im Radio: nach 50 ms noch einmal anstoßen, außer jemand hat inzwischen angehalten. */
      setTimeout(function () {
        if (nr !== lauf || !x.paused || angehalten) { return; }
        try { var q = x.play(); if (q && q.catch) { q.catch(function () {}); } } catch (e) {}
      }, 50);
    }
    /* iOS erlaubt play() nur im Fingertipp: den Tonspieler beim Start einmal mit Stille anstoßen, damit er
       später im Hintergrund von selbst übernehmen darf (wie in der Engine). */
    function entsperre() {
      if (offen || !audio.paused) { return; }
      try {
        audio.src = STILL;
        var p = audio.play();
        if (p && p.then) { p.then(function () { offen = true; }, function () {}); }
      } catch (e) {}
    }

    function fehler(nr) {
      if (nr !== lauf || !aktuell) { return; }
      var z = aktuell.z;
      if (aktuell.v.live) {
        /* Fassung d: Sender weg. Kein iframe (gibt es nicht), nur ein Hinweis. */
        stopp(false);
        if (h.hinweis) { try { h.hinweis('Dieser Sender ist gerade nicht erreichbar.'); } catch (e) {} }
        return;
      }
      if (++fehlerZahl > 2 || imHintergrund()) {
        stopp(false);
        return;
      }
      /* Direkt geht es nicht: im iframe der Section weiter */
      stopp(false);
      if (h.rueckfall) { try { h.rueckfall(z); } catch (e) {} }
    }

    /* Fassung c: Die Tondatei lädt nicht: an derselben Stelle mit der kleinsten HLS-Stufe weiter. */
    function tonRueckfall() {
      var q = tonQuelle;
      tonQuelle = null;
      if (!aktuell || !q || q.nr !== lauf || art !== 'ton') { return; }
      tonKaputt[aktuell.v.k] = true;
      var ab = Math.max(stelleJetzt(audio), q.ab);
      starte('ton', ab, !angehalten && (q.sofort || q.lief));
    }

    function starte(neueArt, ab, sofort) {
      var nr = ++lauf;
      startZeit = Date.now();
      var v = aktuell.v;
      hlsWeg();
      art = neueArt;
      var x = el();
      var anderes = x === audio ? video : audio;
      leere(anderes);
      if (x === audio && still()) { try { audio.pause(); } catch (e) {} }
      zeige(neueArt);
      var url = neueArt === 'ton' ? v.s : v.m;
      ab = Math.max(0, Number(ab) || 0);
      if (v.live) { ab = 0; }   /* Fassung d: live immer an der aktuellen Stelle des Senders */
      startAb = ab;
      startDa = !(ab > 0);
      startSofort = !!sofort;
      startGespielt = false;
      if (sofort) { angehalten = false; }   /* Fassung e: ein gewollter Start gilt als „soll laufen“, auch nach stopp() */
      bedienStand();
      if (neueArt === 'bild' && aktuell.bild) { video.setAttribute('poster', coverAdresse(aktuell.bild, 1200)); }
      /* Fassung c: reine Tondatei, wenn es sie gibt (direkt im <audio>, ohne hls.js) */
      var mitT = neueArt === 'ton' && !!v.t && !tonKaputt[v.k];
      tonQuelle = mitT ? { nr: nr, ab: ab, sofort: sofort !== false, lief: false } : null;
      if (mitT) { url = v.t; }
      var selbst = function () {
        x.addEventListener('loadedmetadata', function () {
          if (nr !== lauf) { return; }
          if (ab > 0 && Math.abs((Number(x.currentTime) || 0) - ab) > 2) { try { x.currentTime = ab; } catch (e) {} }
        }, { once: true });
        x.src = url;
        try { x.load(); } catch (e) {}
        if (sofort) { abspielen(x, nr); }
      };
      if (mitT || (APPLE && kannSelbst(x))) { selbst(); return; }
      ladeHls().then(function (Hls) {
        if (nr !== lauf) { return; }
        if (!Hls || !Hls.isSupported()) {
          if (kannSelbst(x)) { selbst(); } else { fehler(nr); }
          return;
        }
        var cfg = v.live
          ? (neueArt === 'ton' ? { capLevelToPlayerSize: true, startLevel: 0 } : { capLevelToPlayerSize: true })
          : neueArt === 'ton'
            ? { startPosition: ab > 0 ? ab : -1, maxBufferLength: 300, maxMaxBufferLength: 600, maxBufferSize: 60 * 1000 * 1000, backBufferLength: 90 }
            : { startPosition: ab > 0 ? ab : -1, capLevelToPlayerSize: true };
        var me = new Hls(cfg);
        hls = me;
        var netz = 0;
        me.on(Hls.Events.MANIFEST_PARSED, function () {
          if (nr !== lauf || me !== hls) { return; }
          if (sofort) { abspielen(x, nr); }
        });
        me.on(Hls.Events.ERROR, function (ev, d) {
          if (nr !== lauf || me !== hls || !d || !d.fatal) { return; }
          var code = d.response && d.response.code;
          if (code === 403 || code === 404) { fehler(nr); return; }
          if (d.type === Hls.ErrorTypes.NETWORK_ERROR && v.live && ++netz <= 5) {
            /* Fassung d: Sender kurz weg, mit wachsendem Abstand neu versuchen */
            setTimeout(function () { if (nr === lauf && me === hls) { try { me.startLoad(); } catch (e) {} } }, 1500 * netz);
            return;
          }
          if (d.type === Hls.ErrorTypes.NETWORK_ERROR && !v.live && ++netz <= 3) { try { me.startLoad(); return; } catch (e) {} }
          if (d.type === Hls.ErrorTypes.MEDIA_ERROR && !me.__dpfRettung) { me.__dpfRettung = true; try { me.recoverMediaError(); return; } catch (e) {} }
          fehler(nr);
        });
        me.loadSource(url);
        me.attachMedia(x);
      });
    }

    /* ---------------------------------------------------------------- Stellen */
    function sichere(jetzt) {
      if (!aktuell || aktuell.v.live) { return; }
      var x = el();
      var d = Number(x.duration);
      if (!isFinite(d) || d <= 0) { d = aktuell.v.d; }
      var t = stelleJetzt(x);
      if (t <= 0) { return; }
      if (!jetzt && Date.now() - zuletztGemerkt < 5000) { return; }
      zuletztGemerkt = Date.now();
      merke(aktuell.v.k, t, d);
    }
    function zeigeStellen() {
      zeilen.forEach(function (z) {
        var v = datenVon(z);
        if (!v) { return; }
        var b = z.querySelector('[data-dp-frei-spielen]');
        var span = b ? b.querySelector('span') : null;
        var st = v.live ? null : stelle(v.k);
        if (span) { span.textContent = st ? 'Weiter ab ' + zeit(st.p) : 'Abspielen'; }
        var text = z.querySelector('.dp__folge-text');
        var balken = z.querySelector('.dpf__stand');
        var d = (st && st.d) || v.d;
        if (st && d > 0 && text) {
          if (!balken) {
            balken = document.createElement('span');
            balken.className = 'dpf__stand';
            balken.appendChild(document.createElement('span'));
            text.appendChild(balken);
          }
          balken.firstChild.style.width = Math.min(100, Math.round(st.p / d * 100)) + '%';
        } else if (balken) {
          balken.parentNode.removeChild(balken);
        }
      });
      var startText = karte.querySelector('.dp__start [data-dp-start-text]');
      var z0 = zuletzt();
      if (startText) { startText.textContent = z0 ? 'Weiter ab ' + zeit(stelle(datenVon(z0).k).p) : 'Abspielen'; }
    }
    /* Zuletzt gehörte Folge dieser Karte mit gemerkter Stelle */
    function zuletzt() {
      var beste = null, t = 0;
      spielbar.forEach(function (z) {
        var st = stelle(datenVon(z).k);
        if (st && (st.t || 0) > t) { t = st.t || 0; beste = z; }
      });
      return beste;
    }

    /* ---------------------------------------------------------------- Sperrbildschirm */
    function nachbar(schritt) {
      if (!aktuell) { return null; }
      var i = spielbar.indexOf(aktuell.z);
      if (i < 0) { return null; }
      return spielbar[i + schritt] || null;
    }
    function meldeSitzung() {
      if (!MS || !aktuell) { return; }
      if (sitzung !== api) {
        if (sitzung) { gibAb(sitzung); }
        try { fremdeMeta = MS.metadata; } catch (e) { fremdeMeta = null; }
        sitzung = api;
      }
      try {
        var bild = aktuell.bild || albumBild;
        MS.metadata = new window.MediaMetadata({
          title: aktuell.titel || albumTitel,
          artist: aktuell.v.live ? (artist ? artist + ' · LIVE' : 'LIVE') : (artist || 'DNTK-FREE'),
          album: albumTitel,
          artwork: bild ? [96, 256, 512].map(function (b) { return { src: coverAdresse(bild, b), sizes: b + 'x' + b }; }) : []
        });
      } catch (e) {}
      msAktion('play', function () { weiterSpielen(); });
      msAktion('pause', pause);
      msAktion('stop', pause);
      msAktion('seekto', function (d) {
        if (!d || !isFinite(d.seekTime)) { return; }
        startDa = true;
        try { el().currentTime = d.seekTime; } catch (e) {}
      });
      if (spielbar.length > 1) {
        msAktion('previoustrack', titelZurueck);
        msAktion('nexttrack', nachbar(1) ? titelVor : null);
        msAktion('seekbackward', null);
        msAktion('seekforward', null);
      } else if (aktuell.v.live) {
        msAktion('previoustrack', null);
        msAktion('nexttrack', null);
        msAktion('seekbackward', null);
        msAktion('seekforward', null);
      } else {
        msAktion('previoustrack', null);
        msAktion('nexttrack', null);
        msAktion('seekbackward', function (d) { springe(-((d && d.seekOffset) || 15)); });
        msAktion('seekforward', function (d) { springe((d && d.seekOffset) || 30); });
      }
    }
    function springe(sek) {
      var x = el();
      var d = Number(x.duration);
      var t = stelleJetzt(x) + sek;
      startDa = true;
      if (isFinite(d) && d > 0) { t = Math.min(t, d - 1); }
      try { x.currentTime = Math.max(0, t); } catch (e) {}
    }
    function position() {
      if (!MS || sitzung !== api || typeof MS.setPositionState !== 'function') { return; }
      var x = el();
      var d = Number(x.duration);
      if (!isFinite(d) || d <= 0) { return; }
      try { MS.setPositionState({ duration: d, position: Math.min(d, Math.max(0, Number(x.currentTime) || 0)), playbackRate: x.playbackRate || 1 }); } catch (e) {}
    }
    /* Titel zurück (Sperrbildschirm und Taste): nach mehr als 3 s an den Anfang, sonst zum vorigen Eintrag;
       Fassung d: live sofort zum vorigen Sender */
    function titelZurueck() {
      if (!aktuell) { return; }
      var x = el();
      var live = aktuell.v.live;
      if (!live && (Number(x.currentTime) || 0) > 3) { startDa = true; try { x.currentTime = 0; } catch (e) {} bedienStand(); return; }
      var n = nachbar(-1);
      if (n) { spiele(n, true); } else if (!live) { startDa = true; try { x.currentTime = 0; } catch (e) {} bedienStand(); }
    }
    function titelVor() {
      var n = nachbar(1);
      if (n) { spiele(n, true); }
    }
    /* Anhalten durch den Hörer (Sperrbildschirm, Taste): auch einen Start, der noch lädt */
    function pause() {
      angehalten = true;
      haltLauf = lauf;
      startSofort = false;
      try { el().pause(); } catch (e) {}
      bedienStand();
    }
    function weiterSpielen() {
      if (!aktuell) { return; }
      haltLauf = -1;
      /* Abspielen im Sperrbildschirm, während das Video steht: als Ton weiter (Videos laufen dort nicht). */
      if (imHintergrund() && art === 'bild') { autoTon = zuTon(true); if (autoTon) { return; } }
      var x = el();
      /* Fassung e: Live-Sender nach einer Pause neu holen, an der aktuellen Stelle des Senders */
      if (aktuell.v.live && x.paused && (x.getAttribute('src') || hls)) { starte(art || 'bild', 0, true); return; }
      if (x.getAttribute('src') || hls) { abspielen(x, lauf); return; }
      starte(art || 'bild', 0, true);
    }

    /* ---------------------------------------------------------------- Ablauf */
    function spiele(z, sofort) {
      var v = datenVon(z);
      if (!v) { return false; }
      if (aktuell && aktuell.z !== z) { sichere(true); }
      if (h.vorStart) { try { h.vorStart(); } catch (e) {} }
      spieler.forEach(function (s) { if (s !== api) { s.halteAn(); } });
      radioAnhalten();
      istFremd = false;
      fehlerZahl = 0;
      var titelEl = z.querySelector('.dp__folge-titel');
      aktuell = {
        z: z, v: v,
        titel: titelEl ? titelEl.textContent : albumTitel,
        bild: z.getAttribute('data-bild') || albumBild
      };
      jetztText.textContent = aktuell.titel || '';
      var st = stelle(v.k);
      var ab = st ? st.p : 0;
      var neueArt = (wunschTon || imHintergrund()) ? 'ton' : 'bild';
      autoTon = neueArt === 'ton' && !wunschTon;
      if (sofort && neueArt === 'bild') { entsperre(); }
      wechsel = Date.now();
      starte(neueArt, ab, sofort !== false);
      if (h.markiere) { try { h.markiere(z); } catch (e) {} }
      return true;
    }
    function naechste() {
      var n = nachbar(1);
      if (aktuell) { merke(aktuell.v.k, 0, 0); }
      if (n) { spiele(n, true); return true; }
      return false;
    }
    function stopp(merken) {
      angehalten = true;
      if (merken !== false) { sichere(true); }
      lauf++;
      hlsWeg();
      leere(video);
      leere(audio);
      box.hidden = true;
      autoTon = false;
      gibAb(api);
      if (h.markiere) { try { h.markiere(null); } catch (e) {} }
      aktuell = null;
      zeigeUmschalt();
      zeigeStellen();
      wachPruefen();
      if (h.aus) { try { h.aus(); } catch (e) {} }
    }
    function halteAn() {
      if (!aktuell) { return; }
      angehalten = true;
      haltLauf = lauf;
      sichere(true);
      try { if (!video.paused) { video.pause(); } } catch (e) {}
      try { if (!audio.paused) { audio.pause(); } } catch (e) {}
    }

    function zuTon(laufen) {
      if (art !== 'bild' || !aktuell) { return false; }
      if (document.pictureInPictureElement === video || video.webkitPresentationMode === 'picture-in-picture') { return false; }
      var ab = stelleJetzt(video);
      starte('ton', ab, laufen);
      return true;
    }
    function zuBild(laufen) {
      if (art !== 'ton' || !aktuell) { return false; }
      var ab = stelleJetzt(audio);
      starte('bild', ab, laufen);
      return true;
    }

    umschalt.addEventListener('click', function () {
      if (!aktuell) { return; }
      if (art === 'bild') {
        wunschTon = true;
        autoTon = false;
        if (!offen) { entsperre(); }
        zuTon(sollLaufen(video));
      } else {
        wunschTon = false;
        autoTon = false;
        zuBild(sollLaufen(audio));
      }
    });

    /* Fassung e: Tasten und Fortschrittslinie in der Zeile */
    if (inZeile) {
      tasteSpiel.addEventListener('click', function () {
        if (!aktuell) { return; }
        var x = el();
        if (sollLaufen(x) && !x.ended) { pause(); return; }
        wach(true);   /* Dauerton im selben Fingertipp (wie im Radio) */
        weiterSpielen();
        bedienStand();
      });
      if (tasteZurueck) { tasteZurueck.addEventListener('click', titelZurueck); }
      if (tasteVor) { tasteVor.addEventListener('click', titelVor); }
      /* Anzeige nachführen, nur an Ereignissen, die es ohnehin gibt */
      [video, audio].forEach(function (x) {
        ['play', 'playing', 'pause', 'timeupdate', 'loadedmetadata', 'durationchange', 'ended'].forEach(function (ereignis) {
          x.addEventListener(ereignis, function () { if (x === el() && !ziehen) { bedienStand(); } });
        });
      });
      window.addEventListener('resize', function () { platzWert = 0; passeZeile(); bedienStand(); });
      if (leiste) {
        var anteilVon = function (e) {
          var r = leiste.getBoundingClientRect();
          if (!r || !(r.width > 0)) { return 0; }
          return Math.min(1, Math.max(0, (Number(e.clientX) - r.left) / r.width));
        };
        /* Nicht ganz ans Ende: Der Wechsel zur nächsten Folge soll aus dem Spielen heraus passieren. */
        var springeAuf = function (sek) {
          var d = dauer();
          if (!d) { return; }
          startDa = true;
          try { el().currentTime = Math.max(0, Math.min(sek, Math.max(d - 1, 0))); } catch (e) {}
          bedienStand();
        };
        leiste.addEventListener('pointerdown', function (e) {
          if (e.button || !dauer()) { return; }
          ziehen = true;
          ziehAnteil = anteilVon(e);
          try { leiste.setPointerCapture(e.pointerId); } catch (x) {}
          if (e.preventDefault) { e.preventDefault(); }
          leisteStand();
          bedienStand();
        });
        leiste.addEventListener('pointermove', function (e) {
          if (!ziehen) { return; }
          ziehAnteil = anteilVon(e);
          bedienStand();
        });
        leiste.addEventListener('pointerup', function (e) {
          if (!ziehen) { return; }
          ziehAnteil = anteilVon(e);
          ziehen = false;
          leisteStand();
          springeAuf(ziehAnteil * dauer());
        });
        /* Das Handy hat die Bewegung als Scrollen der Seite gewertet: nichts verstellen. */
        leiste.addEventListener('pointercancel', function () {
          if (!ziehen) { return; }
          ziehen = false;
          leisteStand();
          bedienStand();
        });
        leiste.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { zeiger = true; leisteStand(); } });
        leiste.addEventListener('pointerleave', function () { zeiger = false; leisteStand(); });
        leiste.addEventListener('focus', function () {
          var sichtbar = true;
          try { if (leiste.matches) { sichtbar = leiste.matches(':focus-visible'); } } catch (e) {}
          fokus = sichtbar;
          leisteStand();
        });
        leiste.addEventListener('blur', function () { fokus = false; leisteStand(); });
        leiste.addEventListener('keydown', function (e) {
          var schritt = e.key === 'ArrowRight' ? 5 : e.key === 'ArrowLeft' ? -5 : 0;
          if (!schritt) { return; }
          if (e.preventDefault) { e.preventDefault(); }
          springeAuf(stelleJetzt(el()) + schritt);
        });
      }
    }

    /* Ereignisse beider Elemente */
    [video, audio].forEach(function (x) {
      x.addEventListener('play', function () {
        if (x === audio && still()) { return; }
        if (x !== el()) { return; }
        istFremd = false;
        angehalten = false;      /* spielt wieder (auch über die Leiste des Elements gestartet) */
        haltLauf = -1;
        wach(true);
        meldeSitzung();
        if (MS) { try { MS.playbackState = 'playing'; } catch (e) {} }
      });
      x.addEventListener('playing', function () {
        if (x === el() && !(x === audio && still())) { startGespielt = true; }
        if (x === audio && !still()) {
          offen = true;
          if (tonQuelle && tonQuelle.nr === lauf) { tonQuelle.lief = true; }
        }
      });
      x.addEventListener('pause', function () {
        if (x === audio && still()) { return; }
        if (x !== el()) { return; }
        startSofort = false;
        sichere(true);
        zeigeStellen();
        if (MS && sitzung === api) { try { MS.playbackState = 'paused'; } catch (e) {} }
        wachPruefen();
      });
      x.addEventListener('timeupdate', function () {
        if (x !== el() || !aktuell) { return; }
        if (!startDa && (Number(x.currentTime) || 0) >= 1) { startDa = true; }
        if (aktuell.v.live) { return; }   /* Fassung d: live kein Ende, keine Stelle */
        sichere(false);
        var d = Number(x.duration);
        var t = Number(x.currentTime) || 0;
        if (!isFinite(d) || d <= 0) { return; }
        /* Wie im Radio: kurz vor dem Ende zur nächsten Folge, solange noch etwas spielt (Hintergrund). */
        if (!x.paused && t > 2 && t > d - 0.5 && Date.now() - wechsel > 3000) {
          wechsel = Date.now();
          if (!naechste()) { stopp(false); }
        }
      });
      ['loadedmetadata', 'durationchange', 'seeked'].forEach(function (ereignis) {
        x.addEventListener(ereignis, function () { if (x === el()) { position(); } });
      });
      x.addEventListener('ended', function () {
        if (x !== el() || Date.now() - wechsel < 1500) { return; }
        wechsel = Date.now();
        if (aktuell && aktuell.v.live) { stopp(false); return; }   /* Sendung zu Ende: kein automatischer Senderwechsel */
        if (!naechste()) { stopp(false); }
      });
      x.addEventListener('error', function () {
        if (x !== el() || !aktuell || hls) { return; }
        if (x === audio && still()) { return; }
        if (!x.getAttribute('src')) { return; }
        if (x === audio && tonQuelle && tonQuelle.nr === lauf) { tonRueckfall(); return; }
        fehler(lauf);
      });
    });

    /* Etappe 5d wie in der Engine: Seite verschwindet -> als Ton weiter; zurück -> wieder mit Bild. */
    document.addEventListener('visibilitychange', function () {
      if (!aktuell || istFremd) { return; }
      if (imHintergrund()) {
        sichere(true);
        if (art === 'bild' && sollLaufen(video)) { autoTon = zuTon(true); }
        else if (art === 'ton' && audio.paused && Date.now() - tonPause < 1500) { tonNeu(); }
      } else if (art === 'ton' && autoTon && !wunschTon) {
        autoTon = false;
        zuBild(!audio.paused);
      }
    });
    video.addEventListener('pause', function () {
      /* Das Handy hält das Video an, weil die Seite verschwunden ist: als Ton weiter. Hat ein anderes
         Medium übernommen oder der Hörer angehalten (Seite sichtbar), bleibt es still. */
      if (!imHintergrund() || art !== 'bild' || istFremd || angehalten || !aktuell) { return; }
      autoTon = zuTon(true);
    });
    /* Fassung b: Die App hält den Ton beim Verbergen an (Stream mit Bildspur). Dann an derselben Stelle neu
       starten; ein Start nach dem Verbergen läuft dort weiter. Nicht, wenn der Hörer, der Sperrbildschirm
       oder ein anderes Medium angehalten hat, und nicht kurz nach einem eigenen Start (Wechsel). */
    function tonNeu() {
      if (art !== 'ton' || !aktuell || istFremd || angehalten || !audio.paused) { return false; }
      var jetzt = Date.now();
      neustarts = neustarts.filter(function (t) { return jetzt - t < 60000; });
      if (neustarts.length >= 2) { return false; }
      neustarts.push(jetzt);
      tonPause = 0;
      starte('ton', stelleJetzt(audio), true);
      return true;
    }
    audio.addEventListener('pause', function () {
      if (still() || art !== 'ton' || !aktuell || istFremd || angehalten) { return; }
      if (Date.now() - startZeit < 3000) { return; }
      var nr = lauf;
      tonPause = Date.now();
      if (!imHintergrund()) { return; }   /* sichtbar: vielleicht der Hörer; verbirgt sich die Seite gleich, siehe visibilitychange */
      setTimeout(function () {
        if (nr === lauf && imHintergrund()) { tonNeu(); }
      }, 300);
    });
    window.addEventListener('pagehide', function () { sichere(true); });

    var api = {
      kann: function (z) { return !!datenVon(z); },
      spiele: function (z) { return spiele(z, true); },
      laeuft: function () { return !box.hidden; },
      halteAn: halteAn,
      zuletzt: zuletzt,
      spielt: function () {
        return [video, audio].some(function (x) { return !x.paused && !x.ended && !(x === audio && still()); });
      },
      besitzt: function (x) { return x === video || x === audio; },
      fremd: function () {
        if (!aktuell) { return; }
        istFremd = true;
        halteAn();
        gibAb(api);
      },
      stopp: stopp
    };
    karte.__dpfApi = api;
    spieler.push(api);
    zeigeStellen();
    return api;
  }

  window.DNTKFrei = {
    binde: binde,
    halteAlleAn: function () { spieler.forEach(function (s) { s.halteAn(); }); }
  };
  try { document.dispatchEvent(new CustomEvent('dntk-frei:bereit')); } catch (e) {}
})();
